module.exports =
  mockupTemplate:
    base: '/mockupQuery/mockupTemplate'
    detail: '/mockupQuery/mockupTemplate/id/:mockupTemplateId'
    byIdentifier: '/mockupQuery/mockupTemplate/byIdentifier/:identifier'
    bulkByIdentifier: '/mockupQuery/mockupTemplate/bulkByIdentifier'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/mockupQuery.coffee